import React, { createContext, useState, useEffect } from "react";
import { node } from 'prop-types'
import useLocalStorage from "../hooks/useLocalStorage";
import { ValidateLogin } from "../contexts/ValidateLogin";
import api from '../services/api'

export const development = process.env.NODE_ENV === 'development' || window.location.href.includes("homolog-master-motion") || window.location.href.includes("localhost");

export const AuthValidatorContext = createContext();

export const AuthContext = ({ children }) => {
  const [ signed, setSigned] = useState(null);
  const [ userLocalStorage, setUserLocalStorage ] = useLocalStorage('@login-mastermotion/user', null);
  const [ tokenLocalStorage, setTokenLocalStorage ] = useLocalStorage('@login-mastermotion/token', null); 
  // const [ tokenLocalStorage, setTokenLocalStorage ] = useState("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiOGEzODBjZWVkYzYyNTBjZjkyZDJjMGJkY2JlYzg3ODdiZTc1MmQ1NWRmYjI5MzM1NzU1ZWU1YTMwOGYxNTgwNzlkZDcxOGE4MTJkYzVhMmYiLCJpYXQiOjE2NjUxMDE0NDYuOTc1ODU2LCJuYmYiOjE2NjUxMDE0NDYuOTc1ODYsImV4cCI6MTY2NTI3NDI0Ni44NjYwNjYsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.CzlOuV7f9F0-gTLyKH2eTr4eJg1H1lXcs-B1uRF-IV0il8_gcFe8mlmd2r1W_0ZMOAmk9bNkxUB55NYlG6iC8kNTDZYOd1tkAhv5j1qaUIBK6VJOzWT8dqNlziTG0YCWXixNdYOCPeLibY01b_gva07ktJZaUxM11JpBUpX0fipaMlqOFoD9OqWiHDp-gSxmue1ic5vJAPQ89Dra9cmlUhg9UJFRW0ohpuDWtnuEbCHpzjknD2GbjgQaaNAKYqoWDamQLAOER5DE_xpBGr0EL7w5WgfEh_vZ7U8_GYPpw9fse4HOwDXs2xuUUvAvq1x7eTyzJY19CsL0a6MGHgCyZIOkwN8nJZaXiy9Bf5H_zUGtpzg7Ptp-bnYfMbQkssInnVzJvB9jlii6VqRMWHjq3ezXkMGqPVNu2l6zfDSuaDlejdTMSLrhxo71k8YheHmPMlsOnQ_Gacgu5gs2vY3vYziZbrsrPD7_ibQMqFlirqKdjVRkASEXPjq7EOezl-ufXaQGIRhY1qrrxCg-BbtZVotWsljF2p6YE0bkhoqHrPVppx8FqcL_7kLeFJEi2Ycs-ZBdsvHA6i5xle2EVx8BD88HT9x9Ghwm2XEqp6g-7Fe1lfrt7pTL9b16s7410qpKgpCVbbC7hLvQwdn204EGZjR64TRElsnvqdsDdjFjllA"); 
  const [ , setProductsLocalStorage ] = useLocalStorage('@login-mastermotion/products', null);
  const [ auth, setAuth ] = useState(true);
  const [ roles, setRoles ] = useState({
    ia_resources: 0,
    compliance: 0
  });
  
  useEffect(() => {
    if (auth) {
      console.log(development)
      if (development) {
        const fetchBusinessesSigned = () => {
          setSigned(true);
          setRoles({
            ia_resources: 1,
            compliance: 1
          });
        }
        fetchBusinessesSigned();
      } else {
        try {
          const getJwt = async () => {
            const data = await ValidateLogin(tokenLocalStorage);
            console.log('data ValidateLogin')
            console.log(data)
            if (!data.auth) {
              notAuthorize();
            } else {
              if (data.type === "url") {
                setTokenLocalStorage(data.token);
                try {
                  // var url = window.location.href.split("?token=");
                  // if (url.length > 1) window.location.replace(url[0]);
                  setSigned(data.auth);
                } catch (error) { setSigned(data.auth) }
              } else {
                setSigned(data.auth);
              }
              // data.roles.ia_resources = 0;
              // data.roles.compliance = 0;
              setRoles(data.roles);
              setUserLocalStorage(data.user);
            }
          };
          getJwt();
        } catch (error) {
          notAuthorize();
        }
      }
      const fetchBusinessesAuth = () => {
        setAuth(false);
      }
      fetchBusinessesAuth();
        
      }
  });

  function notAuthorize() {
    setTokenLocalStorage(null);
    setUserLocalStorage(null);
    setSigned(false);
    window.location.replace("https://www.reanimateads.com.br/");
  }

  async function recordHash(data) {
    if (development === "development" || window.location.href.includes("homolog-master-motion") || window.location.href.includes("localhost")) return { allowed_access: true };
		try {
      data.product = "f37e3c72-e4af-4ff7-966f-f7f64cd2ce17";
			var json = JSON.stringify(data);
			api.defaults.headers.Authorization = `Bearer ${tokenLocalStorage}`;
			const response = await api.post('/products/tracker', json, {
				headers: {
					'Content-Type': 'application/json'
				}
			});
      return { allowed_access: response.data.allowed_access };
		} catch (e) {
			return { allowed_access: false };
		}
  }

	return (
    <AuthValidatorContext.Provider
      value={{ signed, setSigned, auth, setAuth,
        userLocalStorage, setUserLocalStorage,
        tokenLocalStorage, setTokenLocalStorage,
        setProductsLocalStorage,
        recordHash, roles, setRoles
      }}
    >
      {children}
    </AuthValidatorContext.Provider>
  );
}

AuthContext.propTypes = {
  children: node.isRequired
}